import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LayoutDashboard, Package, BarChart3, LogOut, ExternalLink, Settings } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => { logout(); navigate("/"); };

  const link = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
      isActive ? "bg-[#E53935] text-white" : "text-white/70 hover:bg-white/5 hover:text-white"
    }`;

  return (
    <div className="admin-theme min-h-screen bg-[#0A0A0A] text-[#FAFAFA] flex" data-testid="admin-layout">
      <aside className="w-64 border-r border-white/10 flex flex-col" data-testid="admin-sidebar">
        <div className="p-6 border-b border-white/10">
          <Link to="/" className="font-display font-black text-xl tracking-tighter">CURATED&nbsp;/&nbsp;FOUR</Link>
          <p className="overline text-white/40 mt-2">Operator console</p>
        </div>
        <nav className="flex-1 py-4 space-y-1">
          <NavLink to="/admin" end className={link} data-testid="nav-dashboard">
            <LayoutDashboard className="w-4 h-4" strokeWidth={1.5} /> Dashboard
          </NavLink>
          <NavLink to="/admin/products" className={link} data-testid="nav-products">
            <Package className="w-4 h-4" strokeWidth={1.5} /> Products
          </NavLink>
          <NavLink to="/admin/analytics" className={link} data-testid="nav-analytics">
            <BarChart3 className="w-4 h-4" strokeWidth={1.5} /> Analytics
          </NavLink>
          <NavLink to="/admin/settings" className={link} data-testid="nav-settings">
            <Settings className="w-4 h-4" strokeWidth={1.5} /> Affiliate Setup
          </NavLink>
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <Link to="/" target="_blank" className="flex items-center gap-2 text-xs text-white/60 hover:text-white" data-testid="view-store">
            <ExternalLink className="w-3 h-3" /> View store
          </Link>
          <div className="flex items-center justify-between text-xs pt-2">
            <div>
              <p className="font-semibold text-white">{user?.name}</p>
              <p className="text-white/40 truncate max-w-[140px]">{user?.email}</p>
            </div>
            <button onClick={doLogout} data-testid="logout-btn" className="text-white/60 hover:text-[#E53935]" title="Sign out">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>
      <main className="flex-1 overflow-auto admin-scroll">
        <Outlet />
      </main>
    </div>
  );
}
